/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function SettingsIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="settings"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M9.778 3.667A2.521 2.521 0 0 1 5.894 5.909" data-tinysvg-shape="arc" data-tinysvg-arc="7.26 3.79 2.521 2.521 357.188 482.812 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18.106 5.909A2.521 2.521 60 0 1 14.222 3.667" data-tinysvg-shape="arc" data-tinysvg-arc="16.74 3.79 2.521 2.521 357.188 482.812 60 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.328 14.242A2.521 2.521 120 0 1 20.328 9.758" data-tinysvg-shape="arc" data-tinysvg-arc="21.48 12 2.521 2.521 357.188 482.812 120 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M14.222 20.333A2.521 2.521 180 0 1 18.106 18.091" data-tinysvg-shape="arc" data-tinysvg-arc="16.74 20.21 2.521 2.521 357.188 482.812 180 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M5.894 18.091A2.521 2.521 240 0 1 9.778 20.333" data-tinysvg-shape="arc" data-tinysvg-arc="7.26 20.21 2.521 2.521 357.188 482.812 240 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.672 9.758A2.521 2.521 300 0 1 3.672 14.242" data-tinysvg-shape="arc" data-tinysvg-arc="2.52 12 2.521 2.521 357.188 482.812 300 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M9.778 3.667C9.778 2.746 10.524 2 11.444 2L12.556 2C13.476 2 14.222 2.746 14.222 3.667" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18.106 5.909C18.903 5.449 19.922 5.722 20.382 6.519L20.938 7.481C21.398 8.278 21.125 9.298 20.328 9.758" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.328 14.242C21.125 14.702 21.398 15.722 20.938 16.519L20.382 17.481C19.922 18.278 18.903 18.551 18.106 18.091" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M14.222 20.333C14.222 21.254 13.476 22 12.556 22L11.444 22C10.524 22 9.778 21.254 9.778 20.333" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M5.894 18.091C5.097 18.551 4.078 18.278 3.618 17.481L3.062 16.519C2.602 15.722 2.875 14.702 3.672 14.242" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.672 9.758C2.875 9.298 2.602 8.278 3.062 7.481L3.618 6.519C4.078 5.722 5.097 5.449 5.894 5.909" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={12} cy={12} r={2.778} stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
